import React, { useState, useRef, useEffect } from "react"
import { Col, Container, Row } from "reactstrap"
import { DataTable } from "primereact/datatable"
import { FilterMatchMode } from "primereact/api"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { Toast } from "primereact/toast"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { setPageData } from "store/actions"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
import { t } from "i18next"

const PlacementReport = () => {
  // const [pageState, setPageState] = useState({ first: 0, rows: 10 });
  const dispatch = useDispatch()

  const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
  const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
  const [companyId, setCompanyId] = useState(intialcompanyId);

  const handleCompanyChange = (company) => {
    if (company?.company_id) {
      const selectedId = company.company_id;
      setCompanyId(selectedId);

      const page = Math.floor(first / rows) + 1;
      // fetchPlacementReportData(page, selectedId);
    }
  };



  const { first, rows, totalRecords } = useSelector(
    state => state.calendar.pagination
  )
  const [loading, setLoading] = useState(true)
  const [selectedPlacements, setSelectedPlacements] = useState([])
  const [placements, setPlacements] = useState([])
  const toast = useRef(null)
  const dt = useRef(null)
  document.title = "ATS - Reports"

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    candidate_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    placement_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    days_to_close: { value: null, matchMode: FilterMatchMode.EQUALS },
    start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const onSelectionChange = e => {
    setSelectedPlacements(e.value)
  }

  // const fetchPlacementReportData = async page => {
  const fetchPlacementReportData = async (page, companyId) => {
    setLoading(true);
    try {
      // const response = await axios.get(
      //   `${process.env.REACT_APP_API_BASE_URL}/api/v1/report/placement_report/?page=${page}&size=${rows}`
      // )
       const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/report/placement_report/?page=${page}&size=${rows}&company_id=${companyId}`);
      const apiResponse = response?.data?.results
      const transformedData = apiResponse.map(item => {
        return {
          id: item.id,
          job_id: item.job_number,
          job_title: item.job_title,
          candidate_name: item.candidate_name,
          placement_date: item.placement_date,
          start_date: item.job_start_date,
          end_date: item.job_end_date,
          days_to_close: item.days_to_close,
          user_id: item.user_id,
        }
      })
      setPlacements(transformedData)
      setLoading(false)
      dispatch(
        setPageData({
          first: (page - 1) * rows,
          rows: rows,
          totalRecords: response?.data?.count || 0,
        })
      )
    } catch (error) {
      console.log("error", error.message)
      setLoading(false)
    }
  }
  // useEffect(() => {
  //   const page = Math.floor(first / rows) + 1
  //   fetchPlacementReportData(page)
  // }, [first, rows])

  useEffect(() => {
      if (companyId) {
        const page = Math.floor(first / rows) + 1;
        fetchPlacementReportData(page, companyId);
      }
  }, [first, rows, companyId]);


  const onPage = e => {
    const newPage = Math.floor(e.first / e.rows) + 1
    dispatch(
      setPageData({
        first: e.first,
        rows: e.rows,
        totalRecords,
      })
    )
    // fetchPlacementReportData(newPage , companyId)
  }

  const exportCSV = () => {
    const selectionOnly = selectedPlacements.length > 0
    if (!selectionOnly) {
      toast.current.show({
        severity: "info",
        summary: "Info",
        detail: "No rows selected, exporting all data to CSV.",
        life: 3000,
      })
    }
    dt.current.exportCSV({ selectionOnly })
  }
const exportPdf = () => {
  import("jspdf").then((jsPDF) => {
    import("jspdf-autotable").then(() => {
      const doc = new jsPDF.default("landscape");
      const dataToExport = selectedPlacements.length > 0 ? selectedPlacements : placements;

      if (selectedPlacements.length === 0) {
        toast.current.show({
          severity: "info",
          summary: "Info",
          detail: "No rows selected, exporting all data to PDF.",
          life: 3000,
        });
      }

      const exportColumns = [
        { title: "Job ID", dataKey: "job_id" },
        { title: "Job Title", dataKey: "job_title" },
        { title: "Candidate Name", dataKey: "candidate_name" },
        { title: "Placement Date", dataKey: "placement_date" },
        { title: "No of Days", dataKey: "days_to_close" },
        { title: "Start Date", dataKey: "start_date" },
        { title: "End Date", dataKey: "end_date" },
        { title: "Recruiter Name", dataKey: "user_id" },
      ];

      const formattedData = dataToExport.map(item => {
        const row = {};
        exportColumns.forEach(col => {
          row[col.dataKey] = item[col.dataKey] ?? '';
        });
        return row;
      });

      doc.autoTable({
        columns: exportColumns,
        body: formattedData,
        startY: 20,
        styles: { fontSize: 8, cellPadding: 2 },
        theme: "grid",
        margin: { top: 10, left: 5, right: 5 },
        columnStyles: { 0: { cellWidth: 30 } },
      });

      doc.save("placement_report.pdf");
    });
  });
};

  const exportExcel = () => {
    import("xlsx").then(xlsx => {
      const dataToExport =
        selectedPlacements.length > 0 ? selectedPlacements : placements
      if (selectedPlacements.length === 0) {
        toast.current.show({
          severity: "info",
          summary: "Info",
          detail: "No rows selected, exporting all data to Excel.",
          life: 3000,
        })
      }

      const headers = [
        "Job ID",
        "Job Title",
        "Candidate Name",
        "Status",
        "Placement Date",
        "No of Days",
        "Start Date",
        "End Date",
        "Recruiter Name",
      ]

      const formattedData = dataToExport.map(item => ({
        "Job ID": item.job_id,
        "Job Title": item.job_title,
        "Candidate Name": item.candidate_name,

        "Placement Date": item.placement_date,
        "No of Days": item.days_to_close,
        "Start Date": item.start_date,
        "End Date": item.end_date,
        "Recruiter Name": item.user_id,
      }))

      const worksheet = xlsx.utils.json_to_sheet(formattedData, {
        header: headers,
      })
      worksheet["!cols"] = headers.map(header => ({
        wch: Math.max(header.length, 10),
      }))

      const workbook = {
        Sheets: { "Placement Report": worksheet },
        SheetNames: ["Placement Report"],
      }
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      })

      saveAsExcelFile(excelBuffer, "placement_report")
    })
  }

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then(module => {
      if (module && module.default) {
        const EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        const EXCEL_EXTENSION = ".xlsx"
        const data = new Blob([buffer], { type: EXCEL_TYPE })
        module.default.saveAs(
          data,
          `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`
        )
      }
    })
  }

  const printFile = () => {
    const columns = [
      { title: "Job ID", dataKey: "job_id" },
      { title: "Job Title", dataKey: "job_title" },
      { title: "Candidate Name", dataKey: "candidate_name" },

      { title: "Placement Date", dataKey: "placement_date" },
      { title: "No of Days", dataKey: "days_to_close" },
      { title: "Start Date", dataKey: "start_date" },
      { title: "End Date", dataKey: "end_date" },
      { title: "Recruiter Name", dataKey: "user_id" },
    ]

    const dataToExport =
      selectedPlacements.length > 0 ? selectedPlacements : placements
    if (selectedPlacements.length === 0) {
      toast.current.show({
        severity: "info",
        summary: "Info",
        detail: "No rows selected, printing all data.",
        life: 3000,
      })
    }

    const tableHeaders = columns
      .map(
        col =>
          `<th style="border: 1px solid #ccc; padding: 8px;">${col.title}</th>`
      )
      .join("")
    const tableRows =
      dataToExport.length > 0
        ? dataToExport
            .map(row => {
              return `<tr>${columns
                .map(
                  col =>
                    `<td style="border: 1px solid #ccc; padding: 8px;">${
                      row[col.dataKey] ?? ""
                    }</td>`
                )
                .join("")}</tr>`
            })
            .join("")
        : '<tr><td colspan="9" style="border: 1px solid #ccc; padding: 8px; text-align: center;">No data to print</td></tr>'

    const htmlContent = `
            <html>
            <head>
                <title>Print Placement Report</title>
                <style>
                    table {
                        border-collapse: collapse;
                        width: 100%;
                        margin-top: 20px;
                        font-family: Arial, sans-serif;
                    }
                    th, td {
                        border: 1px solid #ccc;
                        padding: 10px;
                        text-align: left;
                        font-size: 12px;
                    }
                    h2 {
                        text-align: center;
                        font-size: 18px;
                    }
                    @media print {
                        body {
                            margin: 1cm;
                        }
                    }
                </style>
            </head>
            <body>
                <h2>Placement Report</h2>
                <table>
                    <thead><tr>${tableHeaders}</tr></thead>
                    <tbody>${tableRows}</tbody>
                </table>
            </body>
            </html>
        `

    const printWindow = window.open("", "", "height=600,width=900")
    printWindow.document.write(htmlContent)
    printWindow.document.close()
    printWindow.focus()
    printWindow.print()
    printWindow.close()
  }

  return (
    <React.Fragment>
      <div className="page-content allact-tabs">
        <Container fluid={true}>
          <Toast ref={toast} />
          <div className="page-title-box actjobbread">
            <Row className="align-items-center actjobsum">
              <Col sm={6} md={6} lg={8}>
                <h1 className="page-title">Placement Report</h1>
              </Col>
              <Col sm={6} md={6} lg={4}>
                <div className="allbtns d-flex gap-2 justify-content-end">
                  <Button
                    type="button"
                    icon="pi pi-file"
                    rounded
                    onClick={exportCSV}
                    tooltip="Export to CSV"
                    tooltipOptions={{ position: "left" }}
                    className="csvbtn"
                  />
                  <Button
                    type="button"
                    icon="pi pi-file-excel"
                    severity="success"
                    rounded
                    onClick={exportExcel}
                    tooltip="Export to XLS"
                    tooltipOptions={{ position: "top" }}
                    className="xlsbtn"
                  />
                  <Button
                    type="button"
                    icon="pi pi-file-pdf"
                    severity="warning"
                    rounded
                    onClick={exportPdf}
                    tooltip="Export to PDF"
                    tooltipOptions={{ position: "bottom" }}
                    className="pdfbtn"
                  />
                  <Button
                    type="button"
                    icon="pi pi-print"
                    severity="warning"
                    rounded
                    onClick={printFile}
                    tooltip="Print"
                    tooltipOptions={{ position: "bottom" }}
                    className="printbtn"
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xxl={6}>
                <h1 className="page-title mb-4"> </h1>
              </Col>
              <Col xxl={6}>
                <div className="d-flex justify-content-end mt-2">
                   <label className="mt-2 me-2">Select Company</label>
                  <div className="mb-2 me-2" style={{ width: "170px" }}>
                     <CompanySelector onCompanyChange={handleCompanyChange} />  
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <section className="job-datatable-section">
                  <div className="card1 mt-3 mb-4 actjobsumtable">
                    {loading ? (
                        <OrgTableShimmer columns={6} rows={7} titleWidth="220px" />
                       ) : (
                    <DataTable
                      ref={dt}
                      value={placements}
                      rows={rows}
                      lazy
                      paginator
                      first={first}
                      rowsPerPageOptions={[5, 10, 25, 50,totalRecords]}
                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} to {last} of {totalRecords}"
                      onPage={onPage}
                      dataKey="id"
                      filters={filters}
                      filterDisplay="row"
                      loading={loading}
                      globalFilterFields={[
                        "job_id",
                        "job_title",
                        "candidate_name",

                        "placement_date",
                        "days_to_close",
                        "start_date",
                        "end_date",
                        "user_id",
                      ]}
                      scrollable
                      emptyMessage="No records found."
                      selection={selectedPlacements}
                      onSelectionChange={onSelectionChange}
                      selectionMode="multiple"
                      totalRecords={totalRecords}
                      resizableColumns
                      columnResizeMode="expand"
                      id="PlacementReportTable"
                    >
                      <Column
                        field="job_id"
                        sortable
                        header="Job Id"
                        filter
                        filterPlaceholder="Job Id"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column
                        field="job_title"
                        sortable
                        header="Job Title"
                        filter
                        filterPlaceholder="Job Title"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column
                        field="candidate_name"
                        sortable
                        header="Candidate Name"
                        filter
                        filterPlaceholder="Candidate Name"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column
                        field="placement_date"
                        sortable
                        header="Placement Date"
                        filter
                        filterPlaceholder="Placement Date"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column
                        field="days_to_close"
                        sortable
                        header="No of Days"
                        filter
                        filterPlaceholder="No of Days"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column
                        field="start_date"
                        sortable
                        header="Start Date"
                        filter
                        filterPlaceholder="Start Date"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column
                        field="end_date"
                        sortable
                        header="End Date"
                        filter
                        filterPlaceholder="End Date"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column
                        field="user_id"
                        sortable
                        header="Recruiter Name"
                        filter
                        filterPlaceholder="Recruiter Name"
                        style={{ minWidth: "10rem" }}
                      />
                    </DataTable>
                    )}
                  </div>
                </section>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PlacementReport
